// Anonymous (visitor) chat helpers — token storage, REST + WebSocket.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ANON_API = `${BACKEND_URL}/api`;
const WS_BASE = BACKEND_URL.replace(/^http/, "ws");

const TOKEN_KEY = "lh2o_anon_chat_token";
const PROFILE_KEY = "lh2o_anon_chat_profile";

export function getAnonToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setAnonToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}
export function clearAnonChat() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(PROFILE_KEY);
}
export function getAnonProfile() {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}
export function setAnonProfile(profile) {
  if (profile) localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  else localStorage.removeItem(PROFILE_KEY);
}

export const anonApi = axios.create({ baseURL: ANON_API });
anonApi.interceptors.request.use((config) => {
  const token = getAnonToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function buildAnonWsUrl(token) {
  return `${WS_BASE}/api/ws/anonymous/${encodeURIComponent(token)}`;
}

export async function startAnonChat({ name, contact, language }) {
  const { data } = await anonApi.post("/chat/anonymous/start", {
    name,
    contact,
    language,
  });
  setAnonToken(data.token);
  setAnonProfile({ name, contact, conversation_id: data.conversation.id });
  return data;
}
